import { render, staticRenderFns } from "./border_cards.vue?vue&type=template&id=3d9ee5fd&scoped=true&"
import script from "./border_cards.vue?vue&type=script&lang=js&"
export * from "./border_cards.vue?vue&type=script&lang=js&"
import style0 from "./border_cards.vue?vue&type=style&index=0&id=3d9ee5fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ee5fd",
  null
  
)

export default component.exports